import { render, staticRenderFns } from "./NavigationCard.vue?vue&type=template&id=16a8aca4&scoped=true&"
import script from "./NavigationCard.vue?vue&type=script&lang=ts&"
export * from "./NavigationCard.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationCard.vue?vue&type=style&index=0&id=16a8aca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8aca4",
  null
  
)

export default component.exports